<script setup lang="ts"></script>

<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.7986 17.8007C17.4746 18.1215 16.8743 18.0471 16.4578 17.6347L0.368894 1.70219C-0.047619 1.28972 -0.122654 0.695283 0.2013 0.374479C0.525255 0.0536743 1.12553 0.12798 1.54205 0.540442L17.631 16.4729C18.0475 16.8854 18.1225 17.4799 17.7986 17.8007Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.7987 0.199337C18.1227 0.520133 18.0476 1.11459 17.6311 1.52705L1.54217 17.4596C1.12566 17.872 0.525372 17.9463 0.201426 17.6255C-0.122521 17.3047 -0.0474936 16.7103 0.369019 16.2978L16.458 0.3653C16.8745 -0.0471523 17.4748 -0.12146 17.7987 0.199337Z"
      fill="currentColor"
    />
  </svg>
</template>
